<template>
	<div ref="authCreate" class="dialog-container">
		<div class="dialog" style="max-height: 560px; transform: translate(0, -280px);">
			<form @submit.stop="doValidation()">
				<div class="top">
					<p class="txt-crud-title">
						Auth Create
					</p>
				</div>
				<div class="center">
					<table class="tb-crud-horizon">
						<colgroup>
							<col width="17%" />
							<col width="33%" />
							<col width="17%" />
							<col width="33%" />
						</colgroup>
						<tbody>
							<tr>
								<th>
									Auth Code.
								</th>
								<td colspan="3">
									<input
										type="text"
										class="input-crud"
										name="authCode"
										v-model="item.authCode"
										v-validate="'required'"
										data-vv-as="Auth Code"
									/>
									<p class="txt-validation" v-if="errors.has('authCode')">
										* {{ errors.first("authCode") }}
									</p>
								</td>
							</tr>
							<tr>
								<th>
									Auth Name.
								</th>
								<td colspan="3">
									<input
										type="text"
										class="input-crud"
										name="authName"
										v-model="item.authName"
										v-validate="'required'"
										data-vv-as="Auth Name"
									/>
									<p class="txt-validation" v-if="errors.has('authName')">
										* {{ errors.first("authName") }}
									</p>
								</td>
							</tr>
							<tr>
								<th>Register.</th>
								<td>
									{{ item.firstRegistUserName }} ({{ item.firstRegistUserId }})
								</td>
								<th>
									Regist Date.
								</th>
								<td>
									{{ item.firstRegistDate }}
								</td>
							</tr>
							<tr>
								<th>Etc.</th>
								<td colspan="3">
									<textarea
										class="textarea-crud"
										name="authEtc"
										v-model="item.authEtc"
									></textarea>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-save fright" title="Save" @click.stop="doValidation()">
						Save
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "AuthCreate",
	created() {
		this.logger.debug(this, "created()");
		this.item.firstRegistDate = moment().format("YYYY-MM-DD");
		this.item.firstRegistUserId = this.userInfo.userId;
		this.item.firstRegistUserName = this.userInfo.userName;
	},
	data() {
		return {
			item: {}
		};
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current auth?", "Question", "question").then(() => {
							EventBus.$emit("setting-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/auth/insert.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						location.reload();
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the auth registration?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.authCreate.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.authCreate.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("setting-cancel", "isAuthCreate");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
</style>